import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";
import "./src/styles/mains.scss";

const theme = createTheme({
  typography: {
    fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  },
  palette: {
    primary: {
      main: "#556cd6",
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: "#red",
    },
    background: {
      default: "#fff",
    },
  },
});

let isFirstLoad = true;

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`);
  }
};

export const onInitialClientRender = () => {
  if (isFirstLoad) {
    // Remove the server-side injected CSS on client side render
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles && jssStyles.parentElement) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
    isFirstLoad = false;
  }

  // Show the page when styles are loaded
  requestAnimationFrame(() => {
    document.body.classList.add("ready");
  });
};

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0);
  return false;
};

// Ensure theme is consistent across route changes
export const wrapRootElement = ({ element }) => {
  return <MuiThemeProvider theme={theme}>{element}</MuiThemeProvider>;
};
